import axios from "axios";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,
  CLEAR_USERS,
  GET_PROFILE_DETAILS_REQUEST,
  GET_PROFILE_DETAILS_SUCCESS,
  GET_PROFILE_DETAILS_FAIL,
  USER_PROFILE_UPDATE_REQUEST,
  USER_PROFILE_UPDATE_SUCCESS,
  USER_PROFILE_UPDATE_FAIL,
  CONTACT_US_REQUEST,
  CONTACT_US_SUCCESS,
  CONTACT_US_FAIL,
} from "../types/userTypes";
import { firebase } from "../../firebase";
// LOGIN USER

export const login = (phone, history) => async (dispatch) => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      "https://uora.herokuapp.com/api/customers/login",
      { phone },
      config
    );

    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
    history.push("/");
  } catch (err) {
    dispatch({ type: USER_LOGIN_FAIL, payload: err.message });
  }
};

export const socialLogin = (name, email, phone, country, history) => async (
  dispatch
) => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      "https://uora.herokuapp.com/api/customers/social-login",
      { name, email, phone, country },
      config
    );

    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
    history.push("/");
  } catch (err) {
    dispatch({ type: USER_LOGIN_FAIL, payload: err.message });
  }
};

export const loginAdmin = (email, password, history) => async (dispatch) => {
  try {
    dispatch({ type: ADMIN_LOGIN_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      "https://uora.herokuapp.com/api/customers/admin_login",
      { email, password },
      config
    );

    dispatch({ type: ADMIN_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
    history.push("/earnings");
  } catch (err) {
    dispatch({ type: ADMIN_LOGIN_FAIL, payload: err.message });
  }
};

// LOGOUT USER

export const logout = (history) => async (dispatch) => {
  localStorage.removeItem("userInfo");
  firebase.auth().signOut();
  dispatch({ type: USER_LOGOUT });
  dispatch({ type: CLEAR_USERS });
  history.push("/login");
};

// REGISTER

export const register = (name, email, phone, history) => async (dispatch) => {
  try {
    dispatch({ type: USER_REGISTER_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      "https://uora.herokuapp.com/api/customers/register",
      { name, email, phone, country: "holland" },
      config
    );

    dispatch({ type: USER_REGISTER_SUCCESS, payload: data });

    localStorage.setItem("userInfo", JSON.stringify(data));
    history.push('/verification')
  } catch (err) {
    dispatch({ type: USER_REGISTER_FAIL, payload: err.message });
  }
};

// GET PROFILE

export const getProfileDetails = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_PROFILE_DETAILS_REQUEST });

    const config = {
      headers: {
        "x-auth-token": getState().userLogin.userInfo.jwt,
      },
    };

    const { data } = await axios.get(
      `https://uora.herokuapp.com/api/customers/`,
      config
    );

    dispatch({ type: GET_PROFILE_DETAILS_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: GET_PROFILE_DETAILS_FAIL, payload: err.message });
  }
};

// UPDATE PROFILE

// export const updateUserProfile = (user) => async (dispatch, getState) => {
//   try {
//     dispatch({ type: UPDATE_PROFILE_REQUEST });

//     const config = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${getState().userLogin.userInfo.token}`,
//       },
//     };

//     const { data } = await axios.put("/api/users/profile", user, config);

//     dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: data });
//   } catch (err) {
//     dispatch({ type: UPDATE_PROFILE_FAIL, payload: err.message });
//   }
// };

// EDIT USER

// export const editUser = (user) => async (dispatch, getState) => {
//   try {
//     dispatch({ type: EDIT_USER_REQUEST });

//     const config = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${getState().userLogin.userInfo.token}`,
//       },
//     };

//     const { data } = await axios.put(`/api/users/${user._id}`, user, config);

//     dispatch({ type: EDIT_USER_SUCCESS, payload: data });

//     dispatch({ type: USER_PROFILE_SUCCESS, payload: data });
//   } catch (err) {
//     dispatch({ type: EDIT_USER_FAIL, payload: err.message });
//   }
// };

export const userProfileUpdate = (form) => async (dispatch, getState) => {
  try {
    dispatch({ type: USER_PROFILE_UPDATE_REQUEST });

    const config = {
      headers: {
        "x-auth-token": getState().userLogin.userInfo.jwt,
      },
    };

    const { data } = await axios.put(
      `https://uora.herokuapp.com/api/customers/`,
      form,
      config
    );

    dispatch({ type: USER_PROFILE_UPDATE_SUCCESS, payload: data });

    dispatch({ type: GET_PROFILE_DETAILS_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: USER_PROFILE_UPDATE_FAIL, payload: err.message });
  }
};

export const contact = (form) => async (dispatch, getState) => {
  try {
    dispatch({ type: CONTACT_US_REQUEST });

    const config = {
      headers: {
        "x-auth-token": getState().userLogin.userInfo.jwt,
      },
    };

    const { data } = await axios.post(
      `https://uora.herokuapp.com/api/users/contact`,
      form,
      config
    );

    dispatch({ type: CONTACT_US_SUCCESS, payload: data });
  } catch (err) {
    dispatch({ type: CONTACT_US_FAIL, payload: err.message });
  }
};
